import script from "./EbooksDetailsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./EbooksDetailsView.vue?vue&type=script&setup=true&lang=ts"

import "./EbooksDetailsView.vue?vue&type=style&index=0&id=a219c458&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a219c458"]])

export default __exports__